import ZoomIn from '@mui/icons-material/ZoomIn'
import { Tooltip } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useLocation, useNavigate } from 'react-router-dom'

export default function MediaZoom() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const action = params.get('action')
  const zoom = Number(params.get('zoom') ?? 1)

  const handleClick = () => {
    const newZooom = zoom >= 1 && zoom < 5 ? zoom + 0.5 : 1
    navigate(`${location.pathname}?action=zoom&zoom=${newZooom}`)
  }

  return (
    <Tooltip title={action === 'zoom' ? 'Zoom out' : 'Zoom in'} arrow>
      <IconButton color="primary" onClick={handleClick} data-test="zoom" id="zoom-button">
        <ZoomIn />
      </IconButton>
    </Tooltip>
  )
}

MediaZoom.defaultProps = {
  isZoomMode: false,
  handleZoomMode: undefined
}
